module.exports = __webpack_public_path__ + "media/images/home/boxes/tasks_and_notes-9b8c4bd4b2a4410868a8c81d27885811.svg";